<template>
  <div class="app">
    <AppHeader/>
    <div class="app-body">
      <Sidebar :navItems="nav"/>
      <main class="main">
        <breadcrumb :list="list"/>
        <world></world>
        <div v-if="contenido" class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside/>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import nav from '../_nav'
import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'
import World from '@/components/World'
import ENV from 'ENV'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb,
    World
  },
  created () {
    if (sessionStorage.getItem('token')) {
      this.authenticated = true
      this.datos_usuario_autenticado = JSON.parse(sessionStorage.getItem('datos_usuario_autenticado'))
      this.allowed.users = true
    } else {
      this.authenticated = false
    }
  },
  data () {
    return {
      nav: nav.items,
      contenido: true,
      authenticated: false,
      allowed: {
        users: false
      },
      datos_usuario_autenticado: {},
      urlBack: `${ENV.server_back}/api/user/avatar/image/`
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  },
  methods: {
    getUrlAvatarImage (filename) {
      // console.log(filename)
      return this.urlBack + filename.replace('profiles/', '')
    }
  }
}
</script>

<style lang="css">

    .breadcrumb {
        /*margin-bottom: 0;*/
        position: fixed;
        top:55px;
        z-index: 800;
        height: 1.2;
        line-height: 1.2;
        width: 100%;
        border-bottom: none;
        background: rgba(0, 0, 0, 0.3);
        color: fff;
    }

    .breadcrumb .active span{
      color: fff;
    }

</style>



// WEBPACK FOOTER //
// src/containers/Full.vue